export const UPSERT_EXECUTOR = "UPSERT_EXECUTOR"
export const UPSERT_EXECUTOR_SUCCESS = "UPSERT_EXECUTOR_SUCCESS"
export const UPSERT_EXECUTOR_FAIL = "UPSERT_EXECUTOR_FAIL"
 
 export const UPDATE_SIGNATURE_EXECUTOR = "UPDATE_SIGNATURE_EXECUTOR"
 export const UPDATE_SIGNATURE_EXECUTOR_SUCCESS = "UPDATE_SIGNATURE_EXECUTOR_SUCCESS"
 export const UPDATE_SIGNATURE_EXECUTOR_FAIL = "UPDATE_SIGNATURE_EXECUTOR_FAIL"

 
 export const GET_LIST_EXECUTOR = "GET_LIST_EXECUTOR"
 export const GET_LIST_EXECUTOR_SUCCESS = "GET_LIST_EXECUTOR_SUCCESS"
 export const GET_LIST_EXECUTOR_FAIL = "GET_LIST_EXECUTOR_FAIL"

 export const GET_LIST_EXECUTOR_FILTER = "GET_LIST_EXECUTOR_FILTER"

export const SEND_SMS_PAYMENT = "SEND_SMS_PAYMENT"
export const SEND_SMS_PAYMENT_SUCCESS = "SEND_SMS_PAYMENT_SUCCESS"
export const SEND_SMS_PAYMENT_FAIL = "SEND_SMS_PAYMENT_FAIL"

export const INACTIVE_EXECUTOR = "INACTIVE_EXECUTOR"
export const INACTIVE_EXECUTOR_SUCCESS = "INACTIVE_EXECUTOR_SUCCESS"
export const INACTIVE_EXECUTOR_FAIL = "INACTIVE_EXECUTOR_FAIL"

export const FILTER_EXECUTOR = "FILTER_EXECUTOR"
export const FILTER_LOADING = "FILTER_LOADING"

 export const RESET_EXECUTOR_FLAG = "RESET_EXECUTOR_FLAG"
